export type GalleryItem = {
  id: string
  alt: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    id: 'caja',
    alt: 'Caja de empanadas argentinas lista para llevar',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0af22aa2-3ddb-4cf7-8a99-0c6de5b9b478.jpg',
  },
  {
    id: 'abierta',
    alt: 'Empanada abierta mostrando el relleno',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fb49a533-702d-4084-b970-bae147ebd9ce.jpg',
  },
  {
    id: 'bandeja',
    alt: 'Empanadas recién horneadas en bandeja',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2e4b5c00-cbf3-4626-8dce-0745a8af3263.jpg',
  },
  {
    id: 'mesa',
    alt: 'Mesa compartida con empanadas y chimichurri',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/261c33dc-107e-4b5f-8065-c5318e843420.jpg',
  },
  {
    id: 'premium',
    alt: 'Empanada premium de pescado a las finas hierbas',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4a46b7bf-a28a-4768-b6c9-d929243d0f8d.jpg',
  },
  {
    id: 'entrega',
    alt: 'Pedido de empanadas empacado y listo para entregar',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fe821b1c-a048-4efd-b83a-943666497712.jpg',
  },
]
